import React, { useState } from 'react';
import axios from 'axios';
import Styles from './Index.module.css';

const Index = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    lastName: '',
    contact: '',
    email: '',
    isInternational: false,
    internationalCode: '',
  });

  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false); // Novo estado para controlar se o formulário foi enviado

  const isValidEmail = (email) => /\S+@\S+\.\S+/.test(email);
  const isValidPhone = (phone) => /^\d{10,11}$/.test(phone.replace(/\D/g, ''));
  const isValidLastName = (lastName) => /^[a-zA-ZÀ-ÿ\s-]+$/.test(lastName);

  const formatPhoneForSubmit = (phone) => {
    const code = formData.isInternational ? formData.internationalCode || '' : '+55';
    return `${code}${phone.replace(/\D/g, '')}`;
  };

  const formatPhoneForDisplay = (phone) => {
    const cleaned = phone.replace(/\D/g, ''); 
    if (cleaned.length <= 2) return `(${cleaned}`;
    if (cleaned.length <= 7) return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2)}`;
    return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 7)}-${cleaned.slice(7, 11)}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.fullName || !formData.contact || !formData.email || !formData.lastName) {
      alert('Por favor, preencha todos os campos!');
      return;
    }

    if (!isValidEmail(formData.email)) {
      alert('Por favor, insira um e-mail válido!');
      return;
    }

    if (!isValidPhone(formData.contact)) {
      alert('Por favor, insira um número de WhatsApp válido com DDD!');
      return;
    }

    if (!isValidLastName(formData.lastName)) {
      alert('Por favor, insira um sobrenome válido!');
      return;
    }

    setIsLoading(true);

    try {
      const formattedPhone = formatPhoneForSubmit(formData.contact);
      await axios.post(
        'https://api.brevo.com/v3/contacts',
        {
          email: formData.email,
          sms: formattedPhone,
          attributes: {
            NOME: formData.fullName,
            CONTATO: formData.contact,
            SMS: formattedPhone,
            SOBRENOME: formData.lastName,
          },
        },
        {
          headers: {
            'api-key': process.env.REACT_APP_BREVO_API_KEY,
            'Content-Type': 'application/json',
          },
        }
      );

      setFormData({ fullName: '', contact: '', email: '', lastName: '', isInternational: false, internationalCode: '' });
      setIsSubmitted(true); // Definir como "enviado" após sucesso
    } catch (error) {
      console.error('Erro ao enviar o formulário:', error);

      // Verifica se a resposta da API contém erro específico do email já cadastrado
      const errorMessage = error.response?.data?.message || "";

      if (errorMessage.includes("email is already associated with another contact")) {
        alert("Verifique as informações cadastradas e tente novamente.");
      } else if (error.response?.status === 400) {
        alert("Você já está na lista de espera!");
      } else {
        alert("Ocorreu um erro inesperado. Tente novamente mais tarde.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const toggleInternational = () => {
    setFormData({
      ...formData,
      isInternational: !formData.isInternational,
      internationalCode: '',
    });
  };

  return (
    <div id="formulario-inscricao" className={Styles.container}>
      <h2> INSCRIÇÕES <span className={Styles.laranja}>ENCERRADAS</span></h2>
      <p>Cadastre-se na lista de espera para receber o aviso de reabertura em primeira mão.</p>
      <div className={Styles.card}>
        <p>QUERO ENTRAR NA LISTA</p>
        <form onSubmit={handleSubmit} className={Styles.forms}>
          <div className={Styles.namecontainer}>
            <input
              className={Styles.firstname}
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              placeholder="Digite seu nome"
              required
            />
            <input
              className={Styles.lastname}
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              placeholder="Digite seu sobrenome"
              required
            />
          </div>
          <div className={Styles.abaixo}>
            <input
              type="text"
              name="contact"
              value={formData.contact ? formatPhoneForDisplay(formData.contact) : ""}
              onChange={handleChange}
              placeholder="Digite seu WhatsApp com DDD"
              required
            />
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Digite seu melhor e-mail"
              required
            />
            <div className={Styles.checkarea}>
              <input
                type="checkbox"
                checked={formData.isInternational}
                onChange={toggleInternational}
                className={Styles.checkbox}
              />
              <label>Estou em outro país</label>
              {formData.isInternational && (
                <input
                  type="text"
                  name="internationalCode"
                  value={formData.internationalCode}
                  onChange={handleChange}
                  placeholder="Cód. País (ex: +1, +44)"
                  className={Styles.internationalInput}
                />
              )}
            </div>
            <button
              type="submit"
              disabled={isLoading}
              className={isSubmitted ? Styles.submittedButton : Styles.submitButton}
            >
              {isLoading ? 'Enviando...' : isSubmitted ? 'Enviado!' : 'ENVIAR'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Index;
